import React from "react";
import { AuthConsumer } from "../../../Helpers/auth.provider";
import { Spin } from "react-cssfx-loading";

export const SilentRenew = () => (
    <AuthConsumer>
        {({ signinSilentCallback }) => {
            signinSilentCallback();
            return <div style={{
                width:'100%',
                height: '100%',
                display: 'flex',
                alignContent: 'center',
                alignItems: 'center',
                justifyContent: 'center',
              }}><Spin width="200px" height="200px" color="#4654FB"></Spin></div>;
        }}
    </AuthConsumer>
);